// @flow
import { CommonActions } from '@react-navigation/native';
import { compose, withProps } from 'react-recompose';
import { connect } from 'react-redux';
import config from '../../../config';
import Navigation from '../../../lib/navigation';
import { fetchAgreementsByProductOfferings } from '../../../modules/Agreements/actions';
import { isLoggedInSelector } from '../../../modules/Authentication';
import { getCreditableOptionsWithPlan, getLocalCreditableOptionsWithPlan, hasRoamingCreditableOptions } from '../../../modules/AvailableOption/selectors';
import { fetchFreeTrialActivationBonus, freeTrialActivationBonusStateSelector } from '../../../modules/Bonuses';
import {
  getCreditableOptionsWithPlanWithZeroValues,
  getLocalCreditableOptionsWithPlanWithZeroValues,
  isNewOfferValidSelector,
  newOfferPeriodicitySelector,
  newOfferPriceSelector,
} from '../../../modules/NewOffer/selectors';
import { clearChosenPhoneNumber } from '../../../modules/SignUp/PhoneNumber';
import { setVoucherDetailsComeFrom, voucherCurrentVoucherDetailsSelector } from '../../../modules/Voucher';
import type { StateType } from '../../../modules/reducers';
import type { DispatchProps, StateProps } from './ChoosePlan';
import ChoosePlan from './ChoosePlan';

const mapStateToProps = (state: StateType): StateProps => ({
  newOfferPrice: newOfferPriceSelector(state),
  newOfferPeriodicity: newOfferPeriodicitySelector(state),
  isFreeSimPathAvailable: false,
  isOfferValid: isNewOfferValidSelector(state),
  isLoggedIn: isLoggedInSelector(state),
  currentVoucherDetails: voucherCurrentVoucherDetailsSelector(state),
  displayVouchersForChoosePlan: config.displayVouchersForChoosePlan,
  creditableOptions: config.displayRoamingPlanSliders
    ? (config.addZeroOptionForEachService
      ? getLocalCreditableOptionsWithPlanWithZeroValues(state)
      : getLocalCreditableOptionsWithPlan(state))
    : (config.addZeroOptionForEachService
      ? getCreditableOptionsWithPlanWithZeroValues(state)
      : getCreditableOptionsWithPlan(state)),
  freeTrialActivationBonus: freeTrialActivationBonusStateSelector(state),
  hasRoamingOptions: hasRoamingCreditableOptions(state),
});

const mapDispatchToProps: DispatchProps = {
  clearChosenPhoneNumber,
  fetchAgreementsByProductOfferings,
  setVoucherDetailsComeFrom: (comeFrom: string) => setVoucherDetailsComeFrom(comeFrom),
  fetchFreeTrial: () => fetchFreeTrialActivationBonus(),
};

const withFlaggedProps = ownProps => ({
  selectThisPlan: () => {
    ownProps.fetchAgreementsByProductOfferings();
    Navigation.dispatch(CommonActions.navigate({ name: 'chooseNumberDuringActivate' }));
  },
  displayLegalBlurb: config.displayLegalBlurb,
  orderType: 'ACTIVATION',
});

export default compose(connect(mapStateToProps, mapDispatchToProps), withProps(withFlaggedProps))(ChoosePlan);
